import { EntityScreenRow } from 'app/models/entity-screen-row'
import * as types from './types'

/**
 * The read's rows, with the generation the request started under: the
 * reducer drops them if a write has bumped it since (utils/generation.ts).
 */
export const getEntityScreen = (rows: EntityScreenRow[], generation?: number) => ({
  type: types.GET_ENTITY_SCREEN,
  payload: { rows, generation },
})

/**
 * Flip a set of rows to a status the ledger has already accepted.
 *
 * A bulk activate / deactivate answers per entity, and the status is the whole
 * change — so the grid is updated from the answer rather than refetched. PQS
 * projects a command asynchronously, so a refetch fired straight after the
 * response can still be reading the old contracts.
 */
export const setEntityScreenStatuses = (payload: {
  ids: string[]
  status: EntityScreenRow['status']
}) => ({
  type: types.SET_ENTITY_SCREEN_STATUSES,
  payload,
})

/**
 * A write happened that the rows cannot be patched for (a CSV import answers
 * without the records it created). The grid reloads once.
 */
export const invalidateEntityScreen = () => ({
  type: types.INVALIDATE_ENTITY_SCREEN,
  payload: null,
})

/**
 * The read failed. Clears `stale` so nothing retries forever on a persistent
 * failure; the thunk tells the user, and the next mount reloads.
 */
export const entityScreenLoadFailed = () => ({
  type: types.ENTITY_SCREEN_LOAD_FAILED,
  payload: null,
})

export const startLoadingEntityScreen = () => ({
  type: types.START_LOADING_ENTITY_SCREEN,
  payload: null,
})

export const stopLoadingEntityScreen = () => ({
  type: types.STOP_LOADING_ENTITY_SCREEN,
  payload: null,
})
